// extracted by mini-css-extract-plugin
export default {"primary-color":"#006266","secondaryColor":"#ff8945","dateBox":"event-date-box_component_dateBox__icjcB","dayOfWeek":"event-date-box_component_dayOfWeek__+4Klu"};